module.exports = "/images/2ccf3cd9faf3a670c1c19cb67b44fde2.png";